import axios from 'axios'

import queryClient from 'Utils/queryClient'

import { ASSET_TYPE } from '../constants'
import { searchPageStore } from '../index'

const STALE_TIME = 10 * 60 * 1000
const STYLE_COUNTER = 'style'
const TIER_COUNTER = 'subscription_tier'
const COUNTER_OWN_PARAMS = {
  [STYLE_COUNTER]: ['style_bucket'],
  [TIER_COUNTER]: ['subscribed', 'subscription_tier_band'],
}
const PAGING_PARAMS = ['page', 'per_page']

// The All tab renders no Style filter, so it only asks for the plan counts.
const countersFor = assetType => (
  assetType === ASSET_TYPE.ALL ? [TIER_COUNTER] : [STYLE_COUNTER, TIER_COUNTER]
)

// Each counter ignores its own filter server-side, so only a param every requested counter ignores
// can be dropped from the shared request (and its client cache key).
const ignoredParamsFor = counters => [
  ...PAGING_PARAMS,
  ...counters
    .map(counter => COUNTER_OWN_PARAMS[counter])
    .reduce((shared, own) => shared.filter(param => own.includes(param))),
]

let latestRequest = null

export const fetchFilterCounts = (state, { url, params }) => {
  const previousAssetType = latestRequest?.assetType
  const counters = countersFor(state.assetType)

  const countParams = { ...params, filter_counts: counters }
  ignoredParamsFor(counters).forEach((param) => { delete countParams[param] })
  const queryKey = ['searchPageFilterCounts', url, countParams]
  const request = { key: JSON.stringify(queryKey), assetType: state.assetType }
  latestRequest = request

  if (previousAssetType !== state.assetType) {
    searchPageStore.setState({ filterCounts: {} })
  }

  return queryClient
    .fetchQuery({
      queryKey,
      queryFn: ({ signal }) => axios.get(url, { params: countParams, signal }),
      staleTime: STALE_TIME,
      retry: false,
    })
    .then(({ data }) => {
      if (latestRequest !== request) return
      searchPageStore.setState({ filterCounts: data || {} })
    })
    .catch(() => {
      if (latestRequest !== request) return
      searchPageStore.setState({ filterCounts: {} })
    })
}
